import { Component, OnInit } from '@angular/core';
import {InitiateResponseCard} from "../../../../interfaces/card/responses/InitiateResponseCard";
import {Session} from "../../../../interfaces/session-data";
import {SessionService} from "../../../../services/session/session.service";
import {CardService} from "../../../../services/card/card.service";
import {CardSchema} from "../../../../interfaces/card/CardSchema";
import {AuthoriseResponseCard} from "../../../../interfaces/card/responses/AuthoriseResponseCard";
import {environment} from "../../../../../environments/environment";
import { ChargeAmount } from 'src/app/interfaces/SessionDisplayInformation';


interface MerchantSessionRequest {
  merchantIdentifier: string;// "merchant.com.adumoonline";
  displayName: string; //"Adumo Online";
  initiative: string; //"web";
  initiativeContext: string; //"dev-gateway.adumoonline.com";
  validationURL: string; //"https://api.adumoonline.com/payment/validate";
}

@Component({
  selector: 'app-apple-pay-selected',
  templateUrl: './apple-pay-selected.component.html',
  styleUrls: ['./apple-pay-selected.component.scss']
})
export class ApplePaySelectedComponent implements OnInit {
  public link: string;
  initiateResponseCard: InitiateResponseCard;
  navigated: boolean;
  sessionData: Session;
  showSpinner: boolean = false;

  public formSubmitted: boolean = false;
  public iframeLoaded:boolean;
  public iframePostback:boolean;
  private isMobile:boolean;
  public paymentCancelled:boolean;
  // private boundHandleIframeLoad:any;
  availableCardTypes = ['amex', 'discover', 'mastercard', 'visa'];
  filteredCardTypes: string[] = [];
  public showPaymentMethodError: boolean;

  private charge:ChargeAmount;
  constructor( private sessionService:SessionService,
               private cardService: CardService
  ) {
    this.link = "card/apple-pay";
    this.paymentCancelled = false;
  }
  // initiateRequestCard: InitiateApplePayRequestCard;

  ngOnInit(): void {
    // this.setupApplePaySubscription();
    this.iframeLoaded = false;
    this.iframePostback = false;
    this.formSubmitted = false;

    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.filteredCardTypes = this.getSupportedCardTypes();
    console.log(this.filteredCardTypes);
    window.addEventListener('focus', this.handleFocus);
    this.onApplePayButtonClickedJS();
    this.sessionService.getSelectedChargeAmount().subscribe((val)=>this.charge=val);
  }

  ngOnDestroy(): void {
    window.removeEventListener('focus', this.handleFocus);
  }

  extractCodes(cards: CardSchema[]): string[] {
    return cards.map(card => card.code.toLowerCase());
  }

  private getSupportedCardTypes(): string[] {
    if (!this.sessionData || !this.sessionData.virtualConfiguration) {
      return [];
    }
    let enabledCardTypes = this.extractCodes(this.sessionData.virtualConfiguration.supportedCardSchemas);
    //Replace Codes For Diners and Amex as they differ from what is in our Database.
    enabledCardTypes.includes('DINERSCLUB') ? enabledCardTypes.push( 'DISCOVER'.toLowerCase() ) : null;
    enabledCardTypes.includes('AMERICANEXPRESS') ? enabledCardTypes.push( 'AMEX'.toLowerCase() ) : null;
    return enabledCardTypes.filter(code => this.availableCardTypes.includes(code));
  }

  private onApplePayButtonClickedJS() {
    // Define ApplePayPaymentRequest
    console.log(environment.baseUrl+"/apple-pay/validate-merchant");
    this.showSpinner = true;
    this.paymentCancelled = false;
    console.log("onApplePayButtonClickedJS()");
    try {
      if (!(window as any).ApplePaySession) {
        console.log("ApplePay is not supported in this browser.");
        this.showSpinner = false;
        return;
      }

      // Define ApplePayPaymentRequest
      const request = {
        "countryCode": this.sessionData.sessionDisplayInformation.currencyCode.toUpperCase() === 'NAD' ? 'NA' : 'ZA',
        "currencyCode": this.sessionData.sessionDisplayInformation.currencyCode,
        "merchantCapabilities": [
          "supports3DS",
          "supportsCredit",
          "supportsDebit"
        ],
        "supportedNetworks": this.filteredCardTypes,
        "total": {
          "label": this.sessionData.sessionDisplayInformation.label,
          "type": "final",
          "amount": this.sessionData.sessionDisplayInformation.amount.toString(10)
        },
        // "requiredBillingContactFields": [
        //   "name",
        //   "phone",
        //   "email",
        //   "postalAddress"
        // ],
        "requiredShippingContactFields": [
          "name",
          "phone",
          "email"
        ]
      };

      // Create ApplePaySession
      console.log("request: ", request);
      const ApplePaySession = (window as any).ApplePaySession;
      const session = new ApplePaySession(13, request);
      console.log("session: ", session)
      session.onvalidatemerchant = async (event: any) => {
        console.log("event: ", event);
        // Call your own server to request a new merchant session.
        console.log("session.onvalidatemerchant", event);
        const merchantSession = await this.validateMerchant();
        // console.log('Merchant Session:', merchantSession);
        session.completeMerchantValidation(merchantSession);//await this.validateMerchant(event.validationURL));
      };

      // These sections are commented out so they can be easily implemented if their functionality is needed

      // session.onpaymentmethodselected = event => {
      //   console.log("session.onpaymentselected: ", event);
      //   // Define ApplePayPaymentMethodUpdate based on the selected payment method.
      //   // No updates or errors are needed, pass an empty object.
      //   const update = {};
      //   session.completePaymentMethodSelection(update);
      // };
      //
      // session.onshippingmethodselected = event => {
      //   // Define ApplePayShippingMethodUpdate based on the selected shipping method.
      //   // No updates or errors are needed, pass an empty object.
      //   const update = {};
      //   session.completeShippingMethodSelection(update);
      // };
      //
      // session.onshippingcontactselected = event => {
      //   // Define ApplePayShippingContactUpdate based on the selected shipping contact.
      //   const update = {};
      //   session.completeShippingContactSelection(update);
      // };
      //
      session.onpaymentauthorized = (event: any) => {
        this.sessionService.emitPaymentMethodListLock(true);
        // Define ApplePayPaymentAuthorizationResult
        console.log("session.onpaymentauthorized: ", event);
        let payment = event.payment;

        payment.authoriseCurrencyCode = this.sessionData.sessionDisplayInformation.currencyCode != this.charge.currency ? this.charge.currency : undefined;
        payment.authoriseAmount = this.sessionData.sessionDisplayInformation.currencyCode != this.charge.currency ? this.charge.amount : undefined;
        console.log(payment);

        // this.initiateRequestCard = payment;
        this.cardService.initiateApplePayTransaction(payment, sessionStorage.getItem('sessionToken')).subscribe((data: InitiateResponseCard) => {
          this.initiateResponseCard = data;
          console.log("Initiate Response:" + JSON.stringify(this.initiateResponseCard));
          this.navigated = true;
          this.cardService.authoriseTransaction(sessionStorage.getItem('sessionToken'))
            .subscribe((dataAuthorise: AuthoriseResponseCard) => {
              const result = {
                "status": ApplePaySession.STATUS_SUCCESS
              };
              session.completePayment(result);
              this.navigateToStatus();
            }, (err) => {
              console.log("Authorise Error:" + JSON.stringify(err));
              const result = {
                "status": ApplePaySession.STATUS_FAILURE
              };
              session.completePayment(result);
              this.navigateToStatus();
            });
        }, (err) => {
          console.log("Initiate Error:" + JSON.stringify(err));
          const result = {
            "status": ApplePaySession.STATUS_FAILURE
          };
          session.completePayment(result);
          this.navigateToStatus();
        })
      };

      // session.oncouponcodechanged = event => {
      //   // Define ApplePayCouponCodeUpdate
      //   // const newTotal = calculateNewTotal(event.couponCode);
      //   // const newLineItems = calculateNewLineItems(event.couponCode);
      //   // const newShippingMethods = calculateNewShippingMethods(event.couponCode);
      //   // const errors = calculateErrors(event.couponCode);
      //
      //   session.completeCouponCodeChange({
      //     newTotal: newTotal,
      //     newLineItems: newLineItems,
      //     newShippingMethods: newShippingMethods,
      //     errors: errors,
      //   });
      // };

      session.oncancel = (event: any) => {
        this.paymentCancelled = true;
        this.showSpinner = false;
        console.log("session.oncancel: ", event);
        // const result = {
        //   //@ts-ignore
        //   "status": ApplePaySession.STATUS_FAILURE
        // };
        // session.completePayment(result);
        // Payment canceled by WebKit
      };
      session.begin();
      window.setTimeout(() => {
        this.onRemovedFromDOM(this.getAppleModal(), () => {
          this.paymentCancelled = true;
          this.showSpinner = false;
        })
      }, 500)
    } catch (error) {
      console.error('Error creating Apple Pay session:', error);
      this.showSpinner = false;
      this.showPaymentMethodError = true;
    }
  }

  private onRemovedFromDOM(element: Element, callback: () => void): MutationObserver {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.removedNodes.length) {
          //@ts-ignore
          for (let node of mutation.removedNodes) {
            if (node === element || (node as Element).contains(element)) {
              callback();
              observer.disconnect();
              return;
            }
          }
        }
      });
    });

    observer.observe(element.parentNode, {
      childList: true,
      subtree: true
    });

    return observer;
  }

  private handleFocus = () => {
    console.log('Window has gained focus');
    // Insert any logic here to check if the Apple Pay modal is still open or if the payment has been abandoned
  };

  private getAppleModal() {
    const appleModal = document.getElementsByTagName('apple-pay-modal');

    const modalOverlay = appleModal.item(0).shadowRoot.querySelector('.modal-overlay')

    const modalCloseButton = appleModal.item(0).shadowRoot.querySelector('.modal-close-button');

    modalCloseButton.addEventListener('click', () => {
      this.paymentCancelled = true;
      this.showSpinner = false;
      console.log("Modal closed");
    })

    return modalOverlay;
  }

  async validateMerchant() {
    //Post Object
    const merchantSessionRequest: MerchantSessionRequest = {
      merchantIdentifier: "merchant.com.adumoonline",
      displayName: this.sessionData.sessionDisplayInformation.label,
      initiative: "web",
      initiativeContext: environment.applePayInitiativeContext,
      validationURL: environment.applePayValidationURL//url
    };
    // Make a POST request to your server
    const response = await fetch(environment.baseUrl+"/apple-pay/validate-merchant", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(merchantSessionRequest),
    });
    // Check the response status
    if (response.ok) {
      console.log("Validation Success", response)
      // Parse the response as JSON
      const merchantSessionResponse: any = await response.json();
      return merchantSessionResponse;
    } else {
      // Handle the error
      console.error('Failed to validate merchant:', response.statusText);
      return null;
    }
  }
  loading;
  navigateToStatus() {
      this.loading = false;
    //   this.showSpinner = false;
    //   console.log("Apple Pay Navigating To Status")
    //   // Subscribe to router events
    //   this.router.events.pipe(
    //     filter(event => event instanceof NavigationEnd)
    //   ).subscribe(() => {
    //     // Remove the previous route from history
    //     this.location.replaceState(`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`);
    //   });
    //
    //   // window.location.replace(`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`);
    //   this.router.navigate(
    //     [`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`],
    //     {
    //       replaceUrl: true // This replaces the current history entry
    //     });
    // }
    console.log("Apple Pay Navigating To Status")
    const redirectUrl = `${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`;

    // Method 1: window.location.href
    window.location.href = redirectUrl;

    // Method 2: window.open
    setTimeout(() => {
      if (!this.navigated) {
        window.open(redirectUrl, '_self');
      }
    }, 2000);

    // Method 3: meta refresh
    const meta = document.createElement('meta');
    meta.httpEquiv = 'refresh';
    meta.content = `1;url=${redirectUrl}`;
    document.head.appendChild(meta);
  }

  getColorScheme(): string {
    if (this.sessionData && this.sessionData.sessionDisplayInformation && this.sessionData.sessionDisplayInformation.colorScheme) {
      return this.sessionData.sessionDisplayInformation.colorScheme.replace(';', '');
    }
    return 'inherit';
  }

  getTextColor(): string {
    if (this.sessionData && this.sessionData.sessionDisplayInformation && this.sessionData.sessionDisplayInformation.colorScheme) {
      let bgColor:string = this.sessionData.sessionDisplayInformation.colorScheme.replace(';', '');
      let color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      let r = parseInt(color.substring(0, 2), 16); // Red
      let g = parseInt(color.substring(2, 4), 16); // Green
      let b = parseInt(color.substring(4, 6), 16); // Blue

      // Calculate the perceptive luminance
      let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // Return black for bright colors, white for dark colors
      return luminance > 0.5 ? '#000000' : '#FFFFFF';
    }
    return 'inherit';
  }
}
